<template>
	<div class="uk-grid">
		<div class="uk-width-1-2@l">
			<data-table
				ref="timeTable"
				:searchable="false"
				api_point="paylocity/times"
				:per_page=30
				:table_headers="{
				employee_id:{display:'Paylocity Employee Number'},
				job_id:{display:'Paylocity Job Number'},
				first_name:{display:'First Name', sortable:false},
				last_name:{display:'Last Name', sortable:false},
				start:{display:'Punch In'},
				end:{display:'Punch Out'},
			}"
				:actions="{
				edit_path: '/paylocity/time'
			}"
				multi_select=true
				:size_content="true"
			></data-table>
		</div>
		<div class="uk-width-1-2@l">
			<select-matching-requisition @usereq="sendIds"></select-matching-requisition>
			<div class="uk-flex uk-flex-right">
				<a href="/requisitions/edit" class="uk-button uk-button-primary"><i class="fas fa-file"></i> New Requisition</a>
			</div>
		</div>
	</div>
</template>

<script>
import DataTable from "./Table/DataTable";
import SelectMatchingRequisition from "./SelectMatchingRequisition";
export default {
	name: "SelectMultiTimeLog",
	components:{
		DataTable,
		SelectMatchingRequisition
	},
	data() {
		return {}
	},
	mounted() {

	},
	methods: {
		sendIds(reqId){
			let ids = this.$refs.timeTable.selectedRows;
			axios.post("/api/paylocity/times/update", {
				times:ids,
				requisition: reqId
			}).then(
				(pack) => this.idsUpdated(pack)
			).catch(
				() => this.updateFailed()
			);
		},
		idsUpdated(pack){
			this.$refs.timeTable.clearSelections();
			this.$refs.timeTable.refreshPage();
		},
		updateFailed(){

		}
	}
}
</script>
<style scoped></style>